import {initPromoStaticcontent} from "./init";
import WelcomeHeader from "./welcome-header";

window.o_global.eventQBus.on("ft3.promo-staticcontent.init", () => {
    initPromoStaticcontent();
});

window.o_global.eventQBus.on("ft3.promo-staticcontent.init-welcome-header", () => {
    window.o_promo_staticcontent_welcome_header = new WelcomeHeader();
})

window.o_global.eventLoader.onAllPreloadScriptsLoaded(95, () => { window.o_global.eventQBus.emit("ft3.promo-staticcontent.init")})
